<template>
  <a-modal
    title='报名信息'
    :width='700'
    :visible='visible'
    :confirmLoading='confirmLoading'
    @cancel='handleCancel'
    @ok='handleOk'
    okText='确定报名'
  >
    <a-spin :spinning='confirmLoading'>
      <detail-list :col='1' class='font-style'>
        <detail-list-item term='姓名'>{{ dataList.name }}</detail-list-item>
        <detail-list-item term='性别'>{{ dataList.gender }}</detail-list-item>
        <detail-list-item term='身份证号'>{{ dataList.idCard }}</detail-list-item>
        <detail-list-item term='层次'>{{ dataList.level }}</detail-list-item>
        <detail-list-item term='联系电话'>{{ dataList.phoneNumber }}</detail-list-item>
        <detail-list-item term='报考专业'>{{ dataList.profession }}</detail-list-item>
<!--        <detail-list-item term='函授站'>{{ dataList.correspondenceStation }}</detail-list-item>-->
        <detail-list-item term='志愿'>{{ filter(dataList.volunteer) }}</detail-list-item>
      </detail-list>
    </a-spin>
  </a-modal>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import { getDetail } from '@api/adult/customChannel.js'

const DetailListItem = DetailList.Item
export default {
  name: 'ApplyDetail',
  components: {
    DetailList,
    DetailListItem
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      dataList: ''
    }
  },
  methods: {
    filter(value) {
      if (value === '1') {
        return '第一志愿'
      } else if (value === '2') {
        return '第二志愿'
      } else {
        return value
      }
    },
    init(value) {
      this.visible = true
      this.confirmLoading = true
      getDetail(value).then(res => {
        this.dataList = res.data
        this.confirmLoading = false
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleOk() {
      // addObj(this.dataList).then(res => {
      //   this.$message.success('报名成功')
      this.$emit('ok')
      this.visible = false
      // }).catch(err => {
      //   this.$message.error(err.msg)
      // })
    }
  }
}
</script>

<style scoped>
.font-style {
  font-size: 13px;
  margin: 2px 20px;
}
</style>
